module.exports = __webpack_public_path__ + "img/settings-additional.460e562f.svg";